import { DepartmentListComponent } from './department-list/department-list.component';
export var departmentRoutes = [
    {
        path: 'department',
        data: {
            'expectedRoles': ['Admin', 'IT', 'Accountant', 'Accountant Admin', 'UIH', 'Finance Admin', 'IT Admin']
        },
        children: [
            {
                path: 'list',
                component: DepartmentListComponent,
                data: {
                    'expectedRoles': ['Admin', 'Finance Admin', 'Accountant', 'Accountant Admin', 'IT']
                },
            },
            {
                path: 'manage',
                component: DepartmentListComponent,
                data: {
                    'expectedRoles': ['Admin', 'Finance Admin', 'Accountant', 'Accountant Admin', 'IT']
                },
            }
        ],
    }
];
var DepartmentRoutingModule = (function () {
    function DepartmentRoutingModule() {
    }
    return DepartmentRoutingModule;
}());
export { DepartmentRoutingModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/department/department-routing.module.ts.pre-build-optimizer.js